import { Box, Button, Flex, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { isTestMode } from "helpers/application"

import BannerItem from "./banner-item"

const StyledBlockButton = styled(Button).attrs((props) => ({
  forwardedAs: Link,
  height: { _: "70px", desktop: "138px" },
  textDecoration: "underline",
  width: "100%",
  ...props,
}))`
  &:hover {
    text-decoration: none;
    color: ${(props) => props.color};
  }
`

const BannerLink = styled(Link)`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
`

const LandingHeroBanner = ({ element, firstElement, homepage, lazyload }) => {
  const { contain, style } = element
  const { cta, flex_style, items, url } = element.data

  const handleClick = () => {
    if (!isTestMode) {
      dataLayer.push({
        event: "clicked-homepage-banner",
      })
    }
  }

  return (
    <Box containWide={contain} {...style}>
      <Box position="relative" width="100%">
        {url && (
          <BannerLink
            aria-hidden
            data-lc="hero-banner-item"
            to={url}
            {...(homepage && { onClick: handleClick })}
          />
        )}
        <Flex flexDirection={{ _: "column", desktop: "row" }} {...flex_style}>
          {items.map((item, i) => (
            <BannerItem
              element={element}
              firstElement={firstElement && i === 0}
              homepage={homepage}
              item={item}
              key={`hero-banner-item-${i}`}
              lazyload={lazyload}
            />
          ))}
        </Flex>
      </Box>
      {cta && url && (
        <StyledBlockButton
          data-lc="hero-banner"
          to={url}
          {...(homepage && { onClick: handleClick })}
          {...style?.cta}
        >
          <Typography
            fontWeight="600"
            letterSpacing="0.02em"
            textTransform="uppercase"
            variant="body"
          >
            {cta}
          </Typography>
        </StyledBlockButton>
      )}
    </Box>
  )
}

LandingHeroBanner.propTypes = {
  element: PropTypes.object,
  firstElement: PropTypes.bool,
  homepage: PropTypes.bool,
  lazyload: PropTypes.bool,
}

export default LandingHeroBanner
